<template>
  <div class="btn-group search-route-workgroup">
    <button
      type="button"
      class="btn dropdown-toggle"
      data-bs-toggle="dropdown"
      data-bs-display="static"
      aria-expanded="false">
      {{ selected ? selected[labelField] : emptyLabel }}
    </button>
    <ul class="dropdown-menu">
      <div class="input-group px-2">
        <input v-model="filter" type="search" class="form-control" aria-describedby="basic-addon1">
      </div>
      <a v-for="item in filteredItems"
         :key="item.id"
         class="dropdown-item"
         href="#"
         @click.prevent="select(item)">{{ item[labelField] }}
      </a>
    </ul>
  </div>
</template>

<script>
// this component relies on bootstrap 5
export default {
  name: 'ButtonDropdown',
  props: {
    items: {
      type: Array,
      default: () => [],
      required: true,
    },
    initialValue: {
      type: Object,
    },
    labelField: {
      type: String,
      default: 'name',
    },
    emptyLabel: {
      type: String,
      default: '-',
    },
  },
  data() {
    return {
      filter: undefined,
      selected: undefined,
    };
  },
  computed: {
    filteredItems() {
      if (!this.filter) {
        return this.items;
      }
      return this.items.filter((item) => item[this.labelField].toLowerCase().includes(this.filter.toLowerCase()));
    },
  },
  watch: {
    initialValue(newVal) {
      this.selected = newVal;
    },
  },
  mounted() {
    if (this.initialValue) {
      this.selected = { ...this.initialValue };
    }
  },
  methods: {
    select(opt) {
      this.selected = opt;
      this.$emit('select', opt);
    },
  },
};
</script>

<style>

</style>
